<template>
  <div>
    <drawer />
    <v-container>
      <v-row>
        <v-data-table
          :headers="headers"
          :items="alumnos"
          :search="search"
          item-key="id"
          class="elevation-1"
        >
        <template v-slot:no-data>
          <v-row style="margin-top: 10px; text-align: center;">
              <h5>Selecciona el ciclo o ingresa la matrícula del estudiante</h5>
          </v-row>
        </template>
       
          <v-spacer></v-spacer>
          <template v-slot:top>
            <v-toolbar-title class="px-3 py-2">Estudiantes</v-toolbar-title>
            <v-toolbar flat>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar por Matrícula"
                single-line
                hide-details
              ></v-text-field>
              <v-btn class="btn-buscar" @click="buscarAlumno">
                Buscar
              </v-btn>
              <v-spacer></v-spacer>
              <v-select
                v-model="selectedCiclo"
                :items="ciclos"
                label="Seleccionar Ciclo"
                @change="getCiclo"
                style="padding-top: 22px"
              >
              </v-select>
            </v-toolbar>
          </template>
          <template v-slot:item.detalles="{ item }">
            <v-btn class="ma-2" @click="sendStudent(item.cve_alumno)">
              <v-icon> mdi-account-details </v-icon>
            </v-btn>
          </template>
        </v-data-table>

        
      </v-row>
    </v-container>
  </div>
</template>

<script>
import api from "../../http-common";
import AlumnosDataService from "../../services/AlumnosDataService";
import drawer from "../Drawer/Drawer.vue";
import swal from "sweetalert";

export default {
  name: "alumnos",
  data() {
    return {
      alumnos: [],
      selectedCiclo: null,
      alumnosCicloSeleccionado: [],
      search: "",
      headers: [
        {
          text: "Matrícula",
          align: "center",
          sortable: true,
          value: "cve_alumno",
        },
        { text: "Nombres", value: "alumno.nombre" },
        { text: "Apellido paterno", value: "alumno.paterno" },
        { text: "Apellido materno", value: "alumno.materno" },
        { text: "Carrera", sortable: true, value: "desc_carrera" },
        { text: "Ciclo", align: "center", value: "semestre" },
        { text: "Ver detalles", align: "center", value: "detalles" },
      ],

      //ciclos: ["2024-ENE/JUL 1/2 (795)", "2024-AGO/DIC-2/2 (800)"],
      ciclos: [],
      cve_ciclo: [],
    };
  },
  components: {
    drawer,
  },
  methods: {
    retrieveAlumnos() {
      AlumnosDataService.getoalumnos()
        .then((response) => {
          this.alumnos = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    sendStudent(id) {
      console.log(id);
      this.$router.push("/fi-alumnos/" + id);
    },

    buscarAlumno(){
      if(this.search){
        api
        .get(
          "alumnos/movalumno/" + this.search
          /*"http://127.0.0.1:8000/alumnos/movalumno/" + this.search*/
        )
        .then((response) => {
          this.alumnos = [response.data];
        })
        .catch((error) => {
          console.log(error);
          if(error.response && error.response.status === 404){
            swal("Estudiante no encontrado", "No se encontró ningun estudiante con esa matrícula", "warning");
          }
        })
      }else{
        swal("Ingresa una matrícula", "", "warning");
      }
      
    },

    async getCiclo() {
      const token = sessionStorage.getItem("jwtToken");

      try {
        const cicloValue = await this.getCicloValue(this.ciclos);

        if (cicloValue) {
          if (token) {
            api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
            
            try {
              const response = await api.get("alumnos/get_coordinator?cve_ciclo=" + cicloValue);
              this.alumnosCicloSeleccionado = response.data;
              this.alumnos = response.data;  
              //this.retrieveAlumnos();
            } catch (error) {
              console.log("Error en la solicitud de alumnos: ", error);
            }
          } else {
            console.error("No token disponible");
          }
        }
      } catch (error) {
        console.error('Error al obtener el ciclo:', error);
      }

    },

    getCiclosFromAPI() {
      api
        .get("eventos/descCiclo/")
        .then((response) => {
          this.ciclos = [response.data.valor + " (" + response.data.id + ")"];
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCicloValue(){
      return api.get(`eventos/cicloActual/`)
      .then((response) => {
        const cicloId = response.data.id;
        const cicloValor = response.data.valor;

        this.cve_ciclo = `${cicloValor} (${cicloId})`;
        return response.data.valor;
      })
      .catch((error) => {
        console.error("error", error);
      });
    },
  },
  async mounted() {
    //this.retrieveAlumnos();
    this.getCiclosFromAPI();

    const token = sessionStorage.getItem("jwtToken");

    if (token) {
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      api.defaults.headers.common["Access-Control-Allow-Headers"] =
        "Origin, X-Requested-With, Content-Type, Accept";
      api.defaults.headers.common["Access-Control-Allow-Methods"] =
        "GET, POST, PUT, DELETE, OPTIONS";

      try {
        const response = await api.request("alumnos/get_coordinator");
        if (Array.isArray(response.data)) { 
          this.alumnos = response.data;
        }else {
          this.alumnos = [response.data];
        }
      }catch (error) {
        console.error("Error", error);
      }
    }else {
      console.error("No token");
    }
  },
};
</script>

<style>
  .custom-spacer{
    
  }
</style>
